import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  currentPageNo,
  fetchTransactions,
  reset,
  searched,
  selectedType
} from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";

export default function ViewAllTransactions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { transactions, isLoading, isError, type, search, pageNo, totalCount } =
    useSelector((state) => state.transaction);

  const [input, setInput] = useState(search);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(searched(input));
    setInput("");
  };

  useEffect(() => {
    dispatch(fetchTransactions({ type, search, pageNo, isLimit: 10 }));
  }, [dispatch, type, search, pageNo, totalCount]);

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occurred</p>;

  if (!isLoading && !isError && transactions?.length > 0) {
    content = transactions.map((transaction) => (
      <Transaction
        key={transaction.id}
        transaction={transaction}
        isViewAll={true}
      />
    ));
  }

  if (!isLoading && !isError && transactions?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  let pageSize = [];
  for (let i = 1; i <= Math.ceil(+totalCount / 10); i++) {
    pageSize.push(i);
  }

  return (
    <>
      <p className="second_heading">Your Transactions:</p>
      <div className="form">
        <div className="form-group radio">
          <div className="radio_group">
            <input
              required
              type="radio"
              value="income"
              name="type"
              checked={type === "income"}
              onClick={(e) => {
                dispatch(selectedType(e.target.value));
                dispatch(currentPageNo(1));
              }}
            />
            <label>Income</label>
          </div>
          <div className="radio_group">
            <input
              type="radio"
              value="expense"
              name="type"
              placeholder="Expense"
              checked={type === "expense"}
              onClick={(e) => {
                dispatch(selectedType(e.target.value));
                dispatch(currentPageNo(1));
              }}
            />
            <label>Expense</label>
          </div>
          <form onSubmit={handleSubmit}>
            <input
              className="outline-none border-none mr-2"
              type="search"
              name="search"
              placeholder="Search By Name"
              value={input}
              onChange={(e) => {
                setInput(e.target.value);
                dispatch(currentPageNo(1));
              }}
            />
          </form>
        </div>
        {(type || search) && (
          <div>
            <button
              className="btn"
              onClick={() => {
                dispatch(reset());
                dispatch(currentPageNo(1));
                dispatch(selectedType(""));
              }}
            >
              Reset
            </button>
          </div>
        )}
      </div>

      <div className="conatiner_of_list_of_transactions">
        <ul>{content}</ul>
      </div>

      <div className="view-all-pagination container">
        <button
          className="link back-button"
          onClick={() => {
            navigate(-1);
            dispatch(currentPageNo(1));
            dispatch(selectedType(""));
          }}
        >
          <img
            alt="Back"
            className="icon"
            src="https://png.pngtree.com/png-vector/20190412/ourlarge/pngtree-vector-back-icon-png-image_931209.jpg"
          />
          <span>Back To Home</span>
        </button>

        <div className="pagination">
          {pageSize?.map((item, index) => (
            <button
              className="btn bg-blue-100 text-blue-600 px-4 py-1 rounded-full cursor-pointer"
              key={index}
              onClick={() => dispatch(currentPageNo(item))}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
